import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ForeCastService } from 'src/app/private/services/forecast.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service'; // ✅ Add this


@Component({
  selector: 'app-create-forecast',
  templateUrl: './create-forecast.component.html',
  styleUrls: ['./create-forecast.component.scss']
})
export class CreateForecastComponent {
  @Input() formAction = 'Add'; // or 'Update'
  btnLoading = false;

  
  @Input() forecastData: any;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private localstorage: LocalStorageService,
    private api: ForeCastService,
    private toaster: ToastrService,
     private tracker: TrackingService

  ) {}

  forecast: any = {
    forecast_type: '',
    period_start: '',
    period_end: '',
    forecast_amount: null,
    actual_amount: null,
    forecast_selection_type:'',
  };

  @Input() users: any[] = [];
  @Input() teams: any[] = [];

  ngOnInit() {
    if (this.formAction === 'Update') {
      this.forecast = { ...this.forecastData };
      this.selectedUser = this.forecast.user_id;
      this.selectedTeam = this.forecast.team_id;
      this.forecast.forecast_selection_type = this.forecast.forecast_type;
      this.forecast.forecast_type = this.forecast.user_id ? 'individual' : 'team';
    }
  }
  showDateError = false;
  selectedUser = null;
  selectedTeam = null;

  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableSearchFilter: true,
    closeDropDownOnSelection: true
  };

  forecastTypes = [
    'quarterly',
    'monthly',
    'yearly',
    'manual',
  ]

  saveForecast(valid: any) {
    if (!valid || !this.validateDropdown() || !this.validateDates()) return;

    this.btnLoading = true;

    const payload : any = {
      ...this.forecast,
      client_id: this.localstorage.getClientId(),
      created_by: this.localstorage.getUserId(),
      forecast_type: this.forecast.forecast_selection_type,
      user_id: this.forecast.forecast_type === 'individual' ? this.selectedUser : null,
      team_id: this.forecast.forecast_type === 'team' ? this.selectedTeam : null,
    };

   if(this.formAction === 'Add') {
    this.api.createForecast(payload).subscribe({
      next: (res: any) => {
         const desc = `Forecast created with type: ${payload.forecast_type} and ID: ${res.forecast_id}`;
        this.tracker.track("Create", "Forecast", desc); // ✅ Tracker log
        this.toaster.success('Forecast created successfully');
        this.btnLoading = false;
        this.reload.emit();
        this.closeModal();
      },
      error: (e: any) => {
        this.toaster.error('Error creating forecast');
        this.btnLoading = false;
      }
    });
    }else {
      payload.forecast_id = this.forecastData.forecast_id;
      payload.updated_by = this.localstorage.getUserId();
      this.api.updateForecast(payload).subscribe({
        next: (res: any) => {
          const desc = `Forecast updated with ID: ${payload.forecast_id}`;
        this.tracker.track("Update", "Forecast", desc); // ✅ Tracker log
          this.toaster.success('Forecast updated successfully');
          this.btnLoading = false;
          this.reload.emit();
          this.closeModal();
        },
        error: (e: any) => {
          this.toaster.error('Error updating forecast');
          this.btnLoading = false;
        }
      });
    }
  }

  validateDropdown(): boolean {
    if (this.forecast.forecast_type === 'individual' && !this.selectedUser) {
      return false;
    }
    if (this.forecast.forecast_type === 'team' && !this.selectedTeam) {
      return false;
    }
    return true;
  }

  validateDates(): boolean {
    const start = new Date(this.forecast.period_start);
    const end = new Date(this.forecast.period_end);

    if (start && end && end < start) {
      this.toaster.error('Period end date cannot be before period start date.');
      this.showDateError = true;
      return false;
    }

    this.showDateError = false;
    return true;
  }

  closeModal() {
    this.close.emit();
  }
}
